import priceOfferAndroid from "../assets/screenshots/feature-price-offer-android.webp";
import paymentProofIos from "../assets/screenshots/feature-payment-proof-ios.webp";
import deliveryTrackingAndroid from "../assets/screenshots/feature-delivery-tracking-android.webp";
import callOffIos from "../assets/screenshots/feature-call-off-ios.webp";
import verifiedShopfrontAndroid from "../assets/screenshots/feature-verified-shopfront-android.webp";
import profileIos from "../assets/screenshots/feature-profile-ios.webp";

export const trustFeatures = [
  {
    title: '"Last Price?" Ask It Right in the App',
    description:
      "Where a seller takes offers, make or counter one right on the order. Only a price you both accept changes the total, and every offer stays on record.",
    screenshot: priceOfferAndroid,
    platform: "android",
  },
  {
    title: "Payment Proof, From Both Sides",
    description:
      "Buyer and seller each upload proof of payment on every order, so there's a clear record to point to if anything's ever in question.",
    screenshot: paymentProofIos,
    platform: "ios",
  },
  {
    title: "Track Every Order, Start to Finish",
    description:
      "Follow your order from placed to handed over. On deliveries, sellers can share the courier, a tracking link and updates, and a one-time code confirms the handover.",
    screenshot: deliveryTrackingAndroid,
    platform: "android",
  },
  {
    title: "Ready for the Ups and Downs of a Deal",
    description:
      "Deals can fall through. If you both agree, call the order off in the app. If something's wrong, report an issue and our team reviews both sides.",
    screenshot: callOffIos,
    platform: "ios",
  },
  {
    title: "ID-Verified Sellers",
    description:
      "Look for the blue check. Sellers can verify their identity with a government ID for extra assurance, and we can request it from accounts that need a closer look.",
    screenshot: verifiedShopfrontAndroid,
    platform: "android",
  },
  {
    title: "Real Profiles, Not Just Usernames",
    description:
      "Sellers and buyers add a bio, work experience, and education, like a professional network, so you know who's on the other side of the deal.",
    screenshot: profileIos,
    platform: "ios",
  },
];
